// language=GraphQL
export const ALL_TENANT_SETTINGS_QUERY = `query Query($withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {
  tenantSettings: allTravelObjectTenantSettings {
    id
    tenant @include(if: $withTenant) {
      id
      name
      slug
      domain
      externalReference
      cms @include(if: $withTenantCms) {
        id
        homepage @include(if: $withTenantCmsHomepage) {
          id
          name
          onlineStatus
        }
        categories @include(if: $withTenantCmsCategories) {
          id
          name
        }
        pages @include(if: $withTenantCmsPages) {
          id
          name
          onlineStatus
        }
        errorPage404 @include(if: $withTenantCmsErrorPage404) {
          id
          name
          onlineStatus
        }
        errorPage500 @include(if: $withTenantCmsErrorPage500) {
          id
          name
          onlineStatus
        }
        config @include(if: $withTenantCmsConfig) {
          id
        }
      }
      travelTypes @include(if: $withTenantTravelTypes) {
        id
        name
        description
        image @include(if: $withTenantTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      employees @include(if: $withTenantEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTenantEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      emailConfig @include(if: $withTenantEmailConfig) {
        id
        defaultInternalRecipientEmail
        internalBookingRecipientEmails
        bookingConfirmationTemplateId
        bookingConfirmationInternalTemplateId
        bookingRequestConfirmationTemplateId
        bookingWaitlistConfirmationTemplateId
        bookingWaitlistContingentCheckConfirmationTemplateId
        bookingCustomRequestTemplateId
        bookingPassportDataReminderTemplateId
        previewTravelInterestTemplateId
        contactFormTemplateId
        esimInstallationInfoTemplateId
      }
      newsletterProvider @include(if: $withTenantNewsletterProvider) {
        id
        provider
        config @include(if: $withTenantNewsletterProviderConfig) {
          __typename
          ... on MailchimpConfig {
            id
            apiKey
            serverPrefix
            listId

          }
        }
      }
      redirects @include(if: $withTenantRedirects) {
        id
        fromType
        fromUrl
        fromPage @include(if: $withTenantRedirectsFromPage) {
          id
          name
          onlineStatus
        }
        fromTravel @include(if: $withTenantRedirectsFromTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
        toType
        toUrl
        toPage @include(if: $withTenantRedirectsToPage) {
          id
          name
          onlineStatus
        }
        toTravel @include(if: $withTenantRedirectsToTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
      }
      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
        id
        enabled
        datatransMerchantId
        datatransMerchantPw
        ratioFibuAccountNo
        infoText
        datatransThemeConfig
      }
      ratioConfig @include(if: $withTenantRatioConfig) {
        id
        adressgruppe
      }
      content @include(if: $withTenantContent) {
        id
        bookingInsuranceInfo
        co2CompensationInfo
      }
      partnerTenants @include(if: $withTenantPartnerTenants) {
        id
        tenant @include(if: $withTenantPartnerTenantsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        filterCrossLinking
      }
    }
    onlineStatus
    redirectToBooking
    useTiming
    startDate
    endDate
    travelTypes @include(if: $withTravelTypes) {
      id
      name
      description
      image @include(if: $withTravelTypesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_TENANT_SETTINGS_QUERY = `query Query($id: ID!, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {
  tenantSettings: travelObjectTenantSettings(id: $id) {
    id
    tenant @include(if: $withTenant) {
      id
      name
      slug
      domain
      externalReference
      cms @include(if: $withTenantCms) {
        id
        homepage @include(if: $withTenantCmsHomepage) {
          id
          name
          onlineStatus
        }
        categories @include(if: $withTenantCmsCategories) {
          id
          name
        }
        pages @include(if: $withTenantCmsPages) {
          id
          name
          onlineStatus
        }
        errorPage404 @include(if: $withTenantCmsErrorPage404) {
          id
          name
          onlineStatus
        }
        errorPage500 @include(if: $withTenantCmsErrorPage500) {
          id
          name
          onlineStatus
        }
        config @include(if: $withTenantCmsConfig) {
          id
        }
      }
      travelTypes @include(if: $withTenantTravelTypes) {
        id
        name
        description
        image @include(if: $withTenantTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
      employees @include(if: $withTenantEmployees) {
        id
        firstName
        lastName
        jobTitle
        description
        email
        image @include(if: $withTenantEmployeesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
        phone
      }
      emailConfig @include(if: $withTenantEmailConfig) {
        id
        defaultInternalRecipientEmail
        internalBookingRecipientEmails
        bookingConfirmationTemplateId
        bookingConfirmationInternalTemplateId
        bookingRequestConfirmationTemplateId
        bookingWaitlistConfirmationTemplateId
        bookingWaitlistContingentCheckConfirmationTemplateId
        bookingCustomRequestTemplateId
        bookingPassportDataReminderTemplateId
        previewTravelInterestTemplateId
        contactFormTemplateId
        esimInstallationInfoTemplateId
      }
      newsletterProvider @include(if: $withTenantNewsletterProvider) {
        id
        provider
        config @include(if: $withTenantNewsletterProviderConfig) {
          __typename
          ... on MailchimpConfig {
            id
            apiKey
            serverPrefix
            listId

          }
        }
      }
      redirects @include(if: $withTenantRedirects) {
        id
        fromType
        fromUrl
        fromPage @include(if: $withTenantRedirectsFromPage) {
          id
          name
          onlineStatus
        }
        fromTravel @include(if: $withTenantRedirectsFromTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
        toType
        toUrl
        toPage @include(if: $withTenantRedirectsToPage) {
          id
          name
          onlineStatus
        }
        toTravel @include(if: $withTenantRedirectsToTravel) {
          id
          name
          isBestseller
          startDate
          endDate
          executionStatus
          title
          description
          introVideoUrl
          includedServices
          excludedServices
          pricingTable
          priceCalculationInfo
          programType
          programText
          minPrice
          minPriceManualOverride
          currency
        }
      }
      onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
        id
        enabled
        datatransMerchantId
        datatransMerchantPw
        ratioFibuAccountNo
        infoText
        datatransThemeConfig
      }
      ratioConfig @include(if: $withTenantRatioConfig) {
        id
        adressgruppe
      }
      content @include(if: $withTenantContent) {
        id
        bookingInsuranceInfo
        co2CompensationInfo
      }
      partnerTenants @include(if: $withTenantPartnerTenants) {
        id
        tenant @include(if: $withTenantPartnerTenantsTenant) {
          id
          name
          slug
          domain
          externalReference
        }
        filterCrossLinking
      }
    }
    onlineStatus
    redirectToBooking
    useTiming
    startDate
    endDate
    travelTypes @include(if: $withTravelTypes) {
      id
      name
      description
      image @include(if: $withTravelTypesImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
    }
  }
}`

// language=GraphQL
export const CREATE_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateTravelObjectTenantSettingsInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {
    tenantSettings: createTravelObjectTenantSettings(input: $input) {
      id
      tenant @include(if: $withTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantCms) {
          id
          homepage @include(if: $withTenantCmsHomepage) {
            id
            name
            onlineStatus
          }
          categories @include(if: $withTenantCmsCategories) {
            id
            name
          }
          pages @include(if: $withTenantCmsPages) {
            id
            name
            onlineStatus
          }
          errorPage404 @include(if: $withTenantCmsErrorPage404) {
            id
            name
            onlineStatus
          }
          errorPage500 @include(if: $withTenantCmsErrorPage500) {
            id
            name
            onlineStatus
          }
          config @include(if: $withTenantCmsConfig) {
            id
          }
        }
        travelTypes @include(if: $withTenantTravelTypes) {
          id
          name
          description
          image @include(if: $withTenantTravelTypesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        employees @include(if: $withTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTenantEmployeesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        emailConfig @include(if: $withTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          previewTravelInterestTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantNewsletterProvider) {
          id
          provider
          config @include(if: $withTenantNewsletterProviderConfig) {
            __typename
            ... on MailchimpConfig {
              id
              apiKey
              serverPrefix
              listId

            }
          }
        }
        redirects @include(if: $withTenantRedirects) {
          id
          fromType
          fromUrl
          fromPage @include(if: $withTenantRedirectsFromPage) {
            id
            name
            onlineStatus
          }
          fromTravel @include(if: $withTenantRedirectsFromTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          toType
          toUrl
          toPage @include(if: $withTenantRedirectsToPage) {
            id
            name
            onlineStatus
          }
          toTravel @include(if: $withTenantRedirectsToTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }
        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
          id
          enabled
          datatransMerchantId
          datatransMerchantPw
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantContent) {
          id
          bookingInsuranceInfo
          co2CompensationInfo
        }
        partnerTenants @include(if: $withTenantPartnerTenants) {
          id
          tenant @include(if: $withTenantPartnerTenantsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          filterCrossLinking
        }
      }
      onlineStatus
      redirectToBooking
      useTiming
      startDate
      endDate
      travelTypes @include(if: $withTravelTypes) {
        id
        name
        description
        image @include(if: $withTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateTravelObjectTenantSettingsInput, $withTenant: Boolean = false, $withTenantCms: Boolean = false, $withTenantCmsHomepage: Boolean = false, $withTenantCmsCategories: Boolean = false, $withTenantCmsPages: Boolean = false, $withTenantCmsErrorPage404: Boolean = false, $withTenantCmsErrorPage500: Boolean = false, $withTenantCmsConfig: Boolean = false, $withTenantTravelTypes: Boolean = false, $withTenantTravelTypesImage: Boolean = false, $withTenantEmployees: Boolean = false, $withTenantEmployeesImage: Boolean = false, $withTenantEmailConfig: Boolean = false, $withTenantNewsletterProvider: Boolean = false, $withTenantNewsletterProviderConfig: Boolean = false, $withTenantRedirects: Boolean = false, $withTenantRedirectsFromPage: Boolean = false, $withTenantRedirectsFromTravel: Boolean = false, $withTenantRedirectsToPage: Boolean = false, $withTenantRedirectsToTravel: Boolean = false, $withTenantOnlinePaymentConfig: Boolean = false, $withTenantRatioConfig: Boolean = false, $withTenantContent: Boolean = false, $withTenantPartnerTenants: Boolean = false, $withTenantPartnerTenantsTenant: Boolean = false, $withTravelTypes: Boolean = false, $withTravelTypesImage: Boolean = false) {
    tenantSettings: updateTravelObjectTenantSettings(input: $input) {
      id
      tenant @include(if: $withTenant) {
        id
        name
        slug
        domain
        externalReference
        cms @include(if: $withTenantCms) {
          id
          homepage @include(if: $withTenantCmsHomepage) {
            id
            name
            onlineStatus
          }
          categories @include(if: $withTenantCmsCategories) {
            id
            name
          }
          pages @include(if: $withTenantCmsPages) {
            id
            name
            onlineStatus
          }
          errorPage404 @include(if: $withTenantCmsErrorPage404) {
            id
            name
            onlineStatus
          }
          errorPage500 @include(if: $withTenantCmsErrorPage500) {
            id
            name
            onlineStatus
          }
          config @include(if: $withTenantCmsConfig) {
            id
          }
        }
        travelTypes @include(if: $withTenantTravelTypes) {
          id
          name
          description
          image @include(if: $withTenantTravelTypesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
        }
        employees @include(if: $withTenantEmployees) {
          id
          firstName
          lastName
          jobTitle
          description
          email
          image @include(if: $withTenantEmployeesImage) {
            id
            assetId
            publicId
            url
            resourceType
            format
            width
            height
            caption
            title
            description
          }
          phone
        }
        emailConfig @include(if: $withTenantEmailConfig) {
          id
          defaultInternalRecipientEmail
          internalBookingRecipientEmails
          bookingConfirmationTemplateId
          bookingConfirmationInternalTemplateId
          bookingRequestConfirmationTemplateId
          bookingWaitlistConfirmationTemplateId
          bookingWaitlistContingentCheckConfirmationTemplateId
          bookingCustomRequestTemplateId
          bookingPassportDataReminderTemplateId
          previewTravelInterestTemplateId
          contactFormTemplateId
          esimInstallationInfoTemplateId
        }
        newsletterProvider @include(if: $withTenantNewsletterProvider) {
          id
          provider
          config @include(if: $withTenantNewsletterProviderConfig) {
            __typename
            ... on MailchimpConfig {
              id
              apiKey
              serverPrefix
              listId

            }
          }
        }
        redirects @include(if: $withTenantRedirects) {
          id
          fromType
          fromUrl
          fromPage @include(if: $withTenantRedirectsFromPage) {
            id
            name
            onlineStatus
          }
          fromTravel @include(if: $withTenantRedirectsFromTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
          toType
          toUrl
          toPage @include(if: $withTenantRedirectsToPage) {
            id
            name
            onlineStatus
          }
          toTravel @include(if: $withTenantRedirectsToTravel) {
            id
            name
            isBestseller
            startDate
            endDate
            executionStatus
            title
            description
            introVideoUrl
            includedServices
            excludedServices
            pricingTable
            priceCalculationInfo
            programType
            programText
            minPrice
            minPriceManualOverride
            currency
          }
        }
        onlinePaymentConfig @include(if: $withTenantOnlinePaymentConfig) {
          id
          enabled
          datatransMerchantId
          datatransMerchantPw
          ratioFibuAccountNo
          infoText
          datatransThemeConfig
        }
        ratioConfig @include(if: $withTenantRatioConfig) {
          id
          adressgruppe
        }
        content @include(if: $withTenantContent) {
          id
          bookingInsuranceInfo
          co2CompensationInfo
        }
        partnerTenants @include(if: $withTenantPartnerTenants) {
          id
          tenant @include(if: $withTenantPartnerTenantsTenant) {
            id
            name
            slug
            domain
            externalReference
          }
          filterCrossLinking
        }
      }
      onlineStatus
      redirectToBooking
      useTiming
      startDate
      endDate
      travelTypes @include(if: $withTravelTypes) {
        id
        name
        description
        image @include(if: $withTravelTypesImage) {
          id
          assetId
          publicId
          url
          resourceType
          format
          width
          height
          caption
          title
          description
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelObjectTenantSettingsInput) {
    deleteTravelObjectTenantSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_TENANT_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteTravelObjectTenantSettingsInput) {
    forceDeleteTravelObjectTenantSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const ADD_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: addTravelObjectTenantSettingsTravelTypesInput) {
    addTravelObjectTenantSettingsTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const REMOVE_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: removeTravelObjectTenantSettingsTravelTypesInput) {
    removeTravelObjectTenantSettingsTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const CREATE_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: createTravelObjectTenantSettingsTravelTypesInput) {
    createTravelObjectTenantSettingsTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const DELETE_TENANT_SETTINGS_TRAVEL_TYPES_MUTATION = `
  mutation Mutation($input: deleteTravelObjectTenantSettingsTravelTypesInput) {
    deleteTravelObjectTenantSettingsTravelTypes(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const UPDATE_TENANT_SETTINGS_TRAVEL_TYPES_ORDER_MUTATION = `
  mutation Mutation($input: updateTravelObjectTenantSettingsTravelTypesOrderInput) {
    updateTravelObjectTenantSettingsTravelTypesOrder(input: $input) {
      id
      travelTypeIds
    }
  }`

// language=GraphQL
export const TENANT_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravels: Boolean = false) {
  groupedDependents: travelObjectTenantSettingsDependents(id: $id) {
    travels @include(if: $withTravels) {
      id
      name
      isBestseller
      startDate
      endDate
      executionStatus
      title
      description
      introVideoUrl
      includedServices
      excludedServices
      pricingTable
      priceCalculationInfo
      programType
      programText
      minPrice
      minPriceManualOverride
      currency
    }
  }
}`
